export const WrapperDisplay = {
  FLEX: 'flex',
  BLOCK: 'block',
} as const
export type WrapperDisplay =
  (typeof WrapperDisplay)[keyof typeof WrapperDisplay]

export const WrapperFlexDirection = {
  ROW: 'row',
  ROW_REVERSE: 'row-reverse',
  COLUMN: 'column',
  COLUMN_REVERSE: 'column-reverse',
} as const
export type WrapperFlexDirection =
  (typeof WrapperFlexDirection)[keyof typeof WrapperFlexDirection]

export const WrapperAlignItems = {
  NORMAL: 'normal',
  STRETCH: 'stretch',
  CENTER: 'center',
  START: 'start',
  END: 'end',
  FLEX_START: 'flex-start',
  FLEX_END: 'flex-end',
  SELF_START: 'self-start',
  SELF_END: 'self-end',
  BASELINE: 'baseline',
  FIRST_BASELINE: 'first baseline',
  LAST_BASELINE: 'last baseline',
  SAFE_CENTER: 'safe center',
  UNSAFE_CENTER: 'unsafe center',
} as const
export type WrapperAlignItems =
  (typeof WrapperAlignItems)[keyof typeof WrapperAlignItems]

export const WrapperJustifyContent = {
  NORMAL: 'normal',
  CENTER: 'center',
  START: 'start',
  END: 'end',
  FLEX_START: 'flex-start',
  FLEX_END: 'flex-end',
  LEFT: 'left',
  RIGHT: 'right',
  SPACE_BETWEEN: 'space-between',
  SPACE_AROUND: 'space-around',
  SPACE_EVENLY: 'space-evenly',
  STRETCH: 'stretch',
  SAFE_CENTER: 'safe center',
  UNSAFE_CENTER: 'unsafe center',
} as const
export type WrapperJustifyContent =
  (typeof WrapperJustifyContent)[keyof typeof WrapperJustifyContent]

export interface IWrapper {
  margin?: string
  padding?: string
  display?: WrapperDisplay
  flexDirection?: WrapperFlexDirection
  alignItems?: WrapperAlignItems
  justifyContent?: WrapperJustifyContent
  width?: string
  height?: string
  children?: React.ReactNode
}
